import notificationService from '../../services/notificationService/notificationService';
import ngDialogModule from "ng-dialog";

export default angular.module('updateServiceModule', [notificationService, ngDialogModule])
    .service('updateService', function(notify, $timeout, ngDialog) {
        let init = false;
        this.updateState = '';


        
        this.downloadUpdate = () => {
            updater.downloadUpdate();
        };

        /**
         *
         * @param autoDownload new build will be downloaded automatically
         * @param showInitNotification whether notifications "kontroluji aktualizace" and "aplikace je aktualni" will be displayed -
         *                             usable for periodic update checking
         */
        this.checkUpdates = (autoDownload = true, showInitNotification = true) => {
        };

        this.openUpdateModal = (updater) => {
            ngDialog.open({
                template: 'services/updateService/updateModal.tpl.html',
                name: 'updateDialog',
                controller: 'UpdateModalController',
                controllerAs: 'ctrl',
                closeByEscape: false,
                closeByNavigation: false,
                closeByDocument: false,
                width: '75%',
            }).closePromise.then((response) => {

            });
        }

    })
    .controller('UpdateModalController', function($scope, updateService) {
        this.update = () => {
            updateService.downloadUpdate();
            $scope.closeThisDialog('updateDialog');
        }
    })
    .name;



// WEBPACK FOOTER //
// build/services/updateService/updateService.js